import { GridFooterContainer, GridPagination } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';

type CustomFooterProps = {
    totalRowsCount?: number;
};

export function CustomFooter({ totalRowsCount }: CustomFooterProps) {
    return (
        <GridFooterContainer>
            {totalRowsCount !== undefined && (
                <Box sx={{ flex: 1, pl: 2, display: 'flex', alignItems: 'center' }}>
                    <Typography
                        variant="body2"
                        sx={{ whiteSpace: 'nowrap', color: 'text.secondary', fontStyle: 'italic', fontWeight: 500 }}
                    >
                        {`${totalRowsCount} Registros`}
                    </Typography>
                </Box>
            )}
            <GridPagination />
        </GridFooterContainer>
    );
}
